import { Backdrop, CircularProgress, Paper, useTheme } from '@mui/material';

export default function LoadingPage() {
  const theme = useTheme();
  const z = (theme?.zIndex?.modal || 1300) - 1;
  return (
    <Backdrop open sx={{ backgroundColor: 'rgba(255,255,255,0.3)', zIndex: z }}>
      <Paper
        elevation={6}
        sx={{ borderRadius: 3, padding: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <CircularProgress size={50} color="primary" />
      </Paper>
    </Backdrop>
  );
}
